import { useSession } from '../redux/hooks/session';

const useAuthRole = () => useSession((auth) => auth.role);

export default useAuthRole;
